var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseWeb',{staticClass:"many_recruit_btn",attrs:{"logo-img":_vm.logoPhoto,"app-img-arr":_vm.appPhotoArr,"app-name":_vm.appName,"company":_vm.companyName,"icp-num":_vm.icpNum,"download-path":_vm.downloadPath,"one-word":_vm.oneWord,"tow-word":_vm.towWord}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad0a2e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wardrobeDiary.vue
// module id = null
// module chunks = 